export const categories = [
  {
    name: '전체',
    value: 'all',
  },
  {
    name: '붙이류',
    value: 'category1',
  },
  {
    name: '건계종',
    value: 'category2',
  },
  {
    name: '대형종',
    value: 'category3',
  },
];
